import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../lib/cn.js';
import { useLocale } from '../../i18n/locale-context.js';
import { LifecycleIcon } from '../../icons/LifecycleIcon.js';
const TOKEN_CLASSES = {
    info: { solid: 'bg-status-info-solid text-neutral-0', tint: 'bg-status-info-tint-bg text-status-info-tint-fg' },
    good: { solid: 'bg-status-good-solid text-neutral-0', tint: 'bg-status-good-tint-bg text-status-good-tint-fg' },
    warning: {
        solid: 'bg-status-warning-solid text-neutral-0',
        tint: 'bg-status-warning-tint-bg text-status-warning-tint-fg',
    },
    serious: {
        solid: 'bg-status-serious-solid text-neutral-0',
        tint: 'bg-status-serious-tint-bg text-status-serious-tint-fg',
    },
    critical: {
        solid: 'bg-status-critical-solid text-neutral-0',
        tint: 'bg-status-critical-tint-bg text-status-critical-tint-fg',
    },
    neutral: {
        solid: 'bg-status-neutral-solid text-neutral-0',
        tint: 'bg-status-neutral-tint-bg text-status-neutral-tint-fg',
    },
};
export function StatusBadge({ entry, variant = 'tint', icon, label }) {
    const { locale } = useLocale();
    const text = label ?? (locale === 'ne' ? entry.ne : entry.en);
    return (_jsxs("span", { className: cn('inline-flex w-fit items-center gap-1.5 whitespace-normal rounded-full px-2.5 py-1 text-xs font-semibold', TOKEN_CLASSES[entry.token][variant]), children: [_jsx("span", { "aria-hidden": "true", children: icon ?? _jsx(LifecycleIcon, { concept: entry.icon }) }), text] }));
}
//# sourceMappingURL=StatusBadge.js.map